module.exports = __webpack_public_path__ + "static/assets/250b87d414198dc0537236498af13ffe.svg";